<mat-form-field class="input-container" appearance="outline">
    <mat-label>{{ labelKey | translate }}</mat-label>
    <input [value]="formattedDate" matInput [disabled]="isDisabled()" [required]="_isRequired()" readonly>
    <mat-datepicker-toggle matIconSuffix dateTimePicker (selectDate)="ngControl?.control?.setValue($event)" [disabled]="isDisabled()"></mat-datepicker-toggle>
</mat-form-field>
@if (showError()) {
    @for (msg of errorMessages(); track msg) {
        <mat-error>{{ msg }}</mat-error>
    }
}